export default __webpack_public_path__ + "static/media/layout-3.44c42f12.jpg";